// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.form-modal-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  width: 600px;
  max-width: 90%;
  max-height: 90vh;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow-y: hidden;
}

/* Modal Heading */
.form-modal-content h3 {
  font-family: "Fivo Sans Medium", sans-serif;
  color: #b51f25;
  font-size: 1.1em;
  margin-top: 2em;
  margin-bottom: 25px;
  text-align: left;
}

/* Form Row */
.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

/* Form Group */
.form-group {
  flex: 0 0 30%;
  margin: 0 2em 0 2em;
  margin-bottom: 20px;
}

.form-group.full-width {
  flex: 0 0 100%; /* Full width for the textarea */
}

/* Labels and Required Fields */
.form-group label {
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 0.8em;
  color: #333;
  margin-bottom: 5px;
  font-weight: bold;
  display: flex;
  white-space: nowrap;
}

.form-group label .required {
  color: #b51f25;
  margin-left: 5px;
}

/* Input Fields */
.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 0.9em;
  transition: border-color 0.3s ease;
}

/* Focus State for Inputs */
.form-group input:focus,
.form-group textarea:focus {
  border-color: #b51f25;
  outline: none;
}

/* Text Area Specific Styling */
.form-group textarea {
  resize: vertical;
  height: 100px;
}

/* Submit Button */
.submit-button {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 5px;
  background-color: #b51f25;
  color: white;
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 1em;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin: 1.25em 0 0 0.125em;
}

/* Hover State for Button */
.submit-button:hover {
  background-color: #a21e22;
}

/* Close Button */
.modal-close {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  color: #b51f25;
  transition: color 0.3s ease;
}

.modal-close:hover {
  color: #a21e22;
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/Modal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,gCAAgC;AAClD;;AAEA,+BAA+B;AAC/B;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Modal Overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Modal Content */\n.form-modal-content {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  width: 600px;\n  max-width: 90%;\n  max-height: 90vh;\n  position: relative;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  overflow-y: hidden;\n}\n\n/* Modal Heading */\n.form-modal-content h3 {\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  color: #b51f25;\n  font-size: 1.1em;\n  margin-top: 2em;\n  margin-bottom: 25px;\n  text-align: left;\n}\n\n/* Form Row */\n.form-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n/* Form Group */\n.form-group {\n  flex: 0 0 30%;\n  margin: 0 2em 0 2em;\n  margin-bottom: 20px;\n}\n\n.form-group.full-width {\n  flex: 0 0 100%; /* Full width for the textarea */\n}\n\n/* Labels and Required Fields */\n.form-group label {\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 0.8em;\n  color: #333;\n  margin-bottom: 5px;\n  font-weight: bold;\n  display: flex;\n  white-space: nowrap;\n}\n\n.form-group label .required {\n  color: #b51f25;\n  margin-left: 5px;\n}\n\n/* Input Fields */\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 0.9em;\n  transition: border-color 0.3s ease;\n}\n\n/* Focus State for Inputs */\n.form-group input:focus,\n.form-group textarea:focus {\n  border-color: #b51f25;\n  outline: none;\n}\n\n/* Text Area Specific Styling */\n.form-group textarea {\n  resize: vertical;\n  height: 100px;\n}\n\n/* Submit Button */\n.submit-button {\n  width: 100%;\n  padding: 15px;\n  border: none;\n  border-radius: 5px;\n  background-color: #b51f25;\n  color: white;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 1em;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin: 1.25em 0 0 0.125em;\n}\n\n/* Hover State for Button */\n.submit-button:hover {\n  background-color: #a21e22;\n}\n\n/* Close Button */\n.modal-close {\n  position: absolute;\n  top: 15px;\n  right: 20px;\n  background: none;\n  border: none;\n  font-size: 1.5em;\n  cursor: pointer;\n  color: #b51f25;\n  transition: color 0.3s ease;\n}\n\n.modal-close:hover {\n  color: #a21e22;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
